import StudyLogoPDF from "./StudyLogoPDF";
import { Circle, Document, Font, Page, Path, Rect, StyleSheet, Svg, Text, View } from "@react-pdf/renderer";
import * as React from "react";
import moment from "moment";

import fontRobotoRegular from "../../assets/fonts/Roboto/Roboto-Regular.ttf";
import fontRobotoLight from "../../assets/fonts/Roboto/Roboto-Light.ttf";
import fontRobotoBold from "../../assets/fonts/Roboto/Roboto-Bold.ttf";

Font.register({ family: "RobotoRegular", src: fontRobotoRegular });
Font.register({ family: "RobotoLight", src: fontRobotoLight });
Font.register({ family: "RobotoBold", src: fontRobotoBold });

export const isValidPreviousDonation = (donation) => {
    if (!donation || typeof donation !== 'object') return false;
    const montant = Number(donation.montant);
    const date = Number(donation.date);
    return Number.isFinite(montant) && montant > 0
        && Number.isFinite(date) && date > 0
        && !Number.isNaN(new Date(date).getTime());
};

let newDate = new Date();
let month = newDate.getMonth() + 1;
let year = newDate.getFullYear();
let day = newDate.getDate();

if (month < 10) {
  month = "0" + month;
}

if (day < 10) {
  day = "0" + day;
}
const currentDate = `${day}/${month}/${year}`;
const formatEuro = (value) => `${parseInt(value || 0).toLocaleString("en-EN").replace(/,/g, " ")} €`;
const formatPositive = (value) => formatEuro(Math.max(Number(value || 0), 0));
const hasPositiveValue = (value) => Number(value || 0) > 0;

const styles = StyleSheet.create({
  fontRegular: { fontFamily: "RobotoRegular" },
  fontLight: { fontFamily: "RobotoLight" },
  fontBold: { fontFamily: "RobotoBold" },
  page: {
    paddingTop: 20,
    paddingBottom: 85,
  },
  headerRight: {
    marginLeft: "50%",
    marginRight: 40,
    fontSize: 12,
    textAlign: "right",
    lineHeight: 1.5,
    wordBreak: "keep-all",
  },
  headerName: {
    fontSize: 11,
    fontFamily: "RobotoBold",
    wordBreak: "keep-all",
  },
  headerAdress: {
    fontSize: 10,
    fontFamily: "RobotoRegular",
  },
  headerDate: {
    marginTop: 20,
    fontSize: 9.5,
    fontFamily: "RobotoRegular",
  },
  remarque: {
    border: "1px solid grey",
    borderRadius: 3,
    width: "80%",
    marginLeft: "10%",
    fontFamily: "RobotoRegular",
    fontSize: 10,
    marginTop: 25,
    lineHeight: 2,
  },
  remarqueText: {
    marginTop: 8,
    marginLeft: 5,
  },
  resultsTitle: {
    fontSize: 14,
    paddingLeft: "10%",
    width: "100%",
    marginBottom: 10,
    marginTop: 15,
  },
  donataireBlock: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    marginTop: "5px",
    marginBottom: "15px",
    border: "1px solid #71ADD9",
    borderRadius: 3,
    width: "80%",
    marginLeft: "10%",
    fontFamily: "RobotoBold",
    height: "auto",
    minHeight: "150px",
  },
  heritierBlock: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    marginTop: 5,
    marginBottom: 15,
    border: "1px solid #71ADD9",
    borderRadius: 3,
    width: "80%",
    marginLeft: "10%",
    fontFamily: "RobotoBold",
    height: "auto",
  },
  conjointSurvivantBlock: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    marginTop: 5,
    marginBottom: 15,
    border: "1px solid #70B77E",
    borderRadius: 3,
    width: "80%",
    marginLeft: "10%",
    fontFamily: "RobotoBold",
    height: "auto",
  },
  donataireTitle: {
    height: "100%",
    width: "auto",
    fontSize: 13,
    color: "white",
    backgroundColor: "#71ADD9",
    textAlign: "center",
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 40,
  },
  heritierTitle: {
    height: "100%",
    width: "auto",
    fontSize: 13,
    color: "white",
    backgroundColor: "#71ADD9",
    textAlign: "center",
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 20,
  },
  conjointSurvivantTitle: {
    height: "100%",
    width: "auto",
    fontSize: 13,
    color: "white",
    backgroundColor: "#70B77E",
    textAlign: "center",
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 20,
  },
  donateurTitle: {
    width: "100%",
    textAlign: "center",
    color: "white",
    backgroundColor: "rgb(157 114 169)",
    fontSize: 12,
    padding: 10,
  },
  donateurBlock: {
    flex: 1,
    border: "1px solid rgb(157 114 169)",
    borderRadius: 3,
    margin: 10,
    maxWidth: "45%",
  },
  heritierBlock2: {
    flex: 1,
    margin: 10,
    maxWidth: "100%",
  },
  donateurResults: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  dmtgResults: {
    fontWeight: "normal",
    fontSize: 10,
    paddingTop: 5,
    paddingBottom: 5,
  },
  representantTitle: {
    fontSize: 11,
    fontFamily: "RobotoBold",
    color: "#3f6f8f",
    backgroundColor: "rgba(113, 173, 217, 0.18)",
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 8,
    marginTop: 5,
    borderRadius: 3,
  },
  representantTitleLarge: {
    fontSize: 12,
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 10,
  },
  representantBlock: {
    border: "1px solid #c8ddea",
    borderRadius: 4,
    marginTop: 8,
    paddingBottom: 6,
    overflow: "hidden",
  },
  dmtgHighlight: {
    fontFamily: "RobotoBold",
  },
  successionDesignContainer: {
    width: "80%",
    marginLeft: "10%",
  },
  successionSummaryCard: {
    border: "1px solid #dfe6f0",
    borderRadius: 6,
    marginBottom: 12,
  },
  successionSummaryHeader: {
    width: "100%",
    backgroundColor: "#71ADD9",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 8,
    paddingBottom: 8,
  },
  successionSummaryHeaderText: {
    fontSize: 12,
    color: "white",
    textAlign: "center",
    fontFamily: "RobotoBold",
  },
  successionSummaryBody: {
    flexDirection: "row",
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 8,
    paddingRight: 8,
  },
  successionSummaryCol: {
    flex: 1,
    paddingLeft: 5,
    paddingRight: 5,
  },
  successionSummaryAmountsCol: {
    flex: 1.35,
    paddingLeft: 5,
    paddingRight: 10,
  },
  successionSummaryRepartitionCol: {
    flex: 1,
    paddingLeft: 10,
    paddingRight: 0,
  },
  successionRepartitionBox: {
    backgroundColor: "rgba(113, 173, 217, 0.14)",
    borderRadius: 6,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 8,
    paddingRight: 8,
  },
  successionRepartitionTitle: {
    fontSize: 9,
    color: "#49708C",
    fontFamily: "RobotoBold",
    marginBottom: 8,
  },
  successionRepartitionRow: {
    flexDirection: "row",
    alignItems: "center",
    borderBottom: "1px solid #eef1f6",
    paddingTop: 6,
    paddingBottom: 6,
  },
  successionRepartitionRowNoBorder: {
    borderBottom: "0px solid transparent",
  },
  successionRepartitionIcon: {
    width: 18,
    height: 18,
    borderRadius: 9,
    backgroundColor: "#49708C",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 8,
  },
  successionRepartitionIconGreen: {
    backgroundColor: "#70B77E",
  },
  successionRepartitionName: {
    flex: 1,
    color: "#14213d",
    fontSize: 11,
    fontFamily: "RobotoRegular",
  },
  successionRepartitionNameStack: {
    flex: 1,
    flexDirection: "column",
  },
  successionRepartitionNameLine: {
    color: "#14213d",
    fontSize: 11,
    fontFamily: "RobotoRegular",
    lineHeight: 1.2,
  },
  successionRepartitionHeirLine: {
    flexDirection: "row",
    alignItems: "center",
  },
  successionDeathMarkIcon: {
    width: 8,
    height: 12,
    marginLeft: 3,
  },
  successionRepartitionValue: {
    color: "#49708C",
    fontSize: 11,
    fontFamily: "RobotoBold",
  },
  successionField: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "1px solid #eef1f6",
    paddingTop: 5,
    paddingBottom: 5,
  },
  successionOptionField: {
    flexDirection: "column",
    alignItems: "stretch",
  },
  successionOptionValueRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: 6,
  },
  successionOptionQuestion: {
    width: "100%",
    fontSize: 11,
    color: "#14213d",
    fontFamily: "RobotoRegular",
    lineHeight: 1.25,
  },
  successionOptionValueText: {
    fontFamily: "RobotoBold",
    width: "60%",
    fontSize: 11,
    color: "#14213d",
    lineHeight: 1.25,
    paddingRight: 8,
  },
  successionOptionAmount: {
    width: "30%",
    fontSize: 11,
    color: "#14213d",
    textAlign: "right",
    fontFamily: "RobotoRegular",
  },
  successionDmtgField: {
    backgroundColor: "rgba(112, 183, 126, 0.18)",
    paddingTop: 7,
    paddingBottom: 7,
    paddingLeft: 8,
    paddingRight: 8,
    marginTop: 5,
  },
  successionFieldLarge: {
    paddingTop: 7,
    paddingBottom: 7,
  },
  successionFieldLabel: {
    flex: 1,
    fontSize: 11,
    color: "#14213d",
    paddingRight: 14,
  },
  successionFieldLabelLarge: {
    fontSize: 12,
  },
  successionFieldValue: {
    fontSize: 11,
    color: "#14213d",
    textAlign: "right",
    fontFamily: "RobotoRegular",
    marginLeft: 8,
  },
  successionFieldValueLarge: {
    fontSize: 12,
  },
  successionAccentText: {
    color: "#49708C",
    fontFamily: "RobotoBold",
  },
  successionGreenText: {
    color: "#2f6338",
    fontFamily: "RobotoBold",
  },
  successionDmtgText: {
    fontFamily: "RobotoBold",
    color: "#2f6338",
  },
  successionConnector: {
    height: 34,
    marginBottom: 12,
  },
  successionConnectorVertical: {
    height: 18,
    width: 1,
    backgroundColor: "#71ADD9",
    marginLeft: "50%",
  },
  successionConnectorHorizontal: {
    width: "76%",
    marginLeft: "12%",
    borderTop: "1px solid #71ADD9",
  },
  successionCards: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  successionCard: {
    width: "48%",
    border: "1px solid #dfe6f0",
    borderRadius: 6,
    marginLeft: 0,
    marginRight: 0,
    marginBottom: 12,
  },
  successionCardSingle: {
    width: "48%",
  },
  successionCardFullWidth: {
    width: "100%",
  },
  successionCardHeader: {
    flexDirection: "row",
    alignItems: "center",
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 8,
    paddingRight: 8,
  },
  successionCardHeaderBlue: {
    backgroundColor: "#71ADD9",
  },
  successionCardHeaderGreen: {
    backgroundColor: "#70B77E",
  },
  successionCardIcon: {
    width: 16,
    height: 16,
    borderRadius: 8,
    backgroundColor: "#49708C",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 6,
  },
  successionCardIconGreen: {
    backgroundColor: "#5FAE71",
  },
  successionSummaryIcon: {
    width: 12,
    height: 12,
    marginRight: 6,
  },
  successionCardTitle: {
    color: "white",
    fontFamily: "RobotoBold",
    fontSize: 11,
  },
  successionCardTitleRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  successionCardTitleLarge: {
    fontSize: 12,
  },
  successionCardBody: {
    paddingTop: 8,
    paddingBottom: 10,
    paddingLeft: 8,
    paddingRight: 8,
  },
  successionCardBodyLarge: {
    paddingTop: 10,
    paddingBottom: 12,
    paddingLeft: 10,
    paddingRight: 10,
  },
  bodyFooterCtn: {
    width: "80%",
    marginLeft: "10%",
    position: "absolute",
    bottom: 15,
    left: 0,
    right: 0,
  },
  bodyFooterBold: {
    fontFamily: "RobotoBold",
    fontSize: 8,
    marginTop: 10,
    textAlign: "justify",
  },
  bodyFooterLight: {
    fontFamily: "RobotoLight",
    fontSize: 6,
    marginTop: 5,
  },
  bodyFooterMapped: {
    fontSize: 8,
    marginTop: 4,
  },
  bodyFooterMappedTitle: {
    fontSize: 8,
    marginTop: 4,
    fontFamily: "RobotoBold",
  },
  rappel: {
    width: "80%",
    marginLeft: "10%",
    marginTop: 30,
    marginBottom: 50,
  },
  containerTitleSimu: {
    position: "relative",
    marginTop: 20,
    marginRight: "auto",
    marginLeft: "auto",
    width: "75%",
  },
  titleSimu: {
    fontSize: 14,
    textAlign: "center",
    fontFamily: "RobotoBold",
    wordBreak: "keep-all",
  },

  rappelBlockDonataire: {
    width: "48%",
    marginTop: 5,
    marginBottom: 10,
  },
  rappelGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  rappelGridTitle: {
    width: "100%",
  },

  rappelDonateurTitle: {
    fontSize: 10,
    marginTop: 5,
    fontWeight: "bold",
    color: "rgb(157 114 169)",
  },

  rappelDonataireTitle: {
    fontSize: 9,
    fontWeight: "bold",
    color: "#71ADD9",
  },
  rappelConjointSurvivantTitle: {
    fontSize: 9,
    fontWeight: "bold",
    color: "#70B77E",
  },
  resultsBlock: {
    marginTop: 5,
    marginBottom: 10,
  },
});

const GenerateDMTGPdfFile = ({ simulateurObject, embedded = false, requestSimuOverride = null }) => {
  let remarque = localStorage.getItem("remarque");

  let currUser = JSON.parse(localStorage.getItem("user"));

  let requestSimu = requestSimuOverride || JSON.parse(localStorage.getItem("dmtgInputs"));

  let nameSimu = localStorage.getItem("nameSimuDMTG");

  let result = simulateurObject;

  let simuDMTGSuccession = [55];
  let conjointSurvivantPdf = null;
  try {
    conjointSurvivantPdf = JSON.parse(localStorage.getItem("conjointSurvivantDMTG"));
  } catch (e) {
    conjointSurvivantPdf = null;
  }
  const hasConjointSurvivantCard = conjointSurvivantPdf?.resultItems?.length > 0;
  const successionResultCardsCount = (hasConjointSurvivantCard ? 1 : 0) + (result?.length || 0);
  const hasSingleHeirCard = (result?.length || 0) === 1;
  const hasManyRepresentants = (requestSimu?.data?.[0]?.donataires || []).some((donataire) => (
    parseInt(donataire?.inputs?.est_represente || 0) === 1
    && parseInt(donataire?.inputs?.nombre_representants || donataire?.representants?.length || 0) >= 2
  ));

  const getDmtgSuccessionSharingItems = () => {
    if (!simuDMTGSuccession.includes(requestSimu?.data?.[0]?.donataires?.[0]?.simulateurid)) return [];
    return (requestSimu?.data?.[0]?.donataires || []).map((donataire, index) => {
      const represented = parseInt(donataire?.inputs?.est_represente || 0) === 1;
      return {
        key: `repartition_${index}`,
        name: `${represented ? "Souche" : "Héritier"} ${index + 1}`,
        represented,
        heirName: `Héritier ${index + 1}`,
        soucheName: `Souche ${index + 1}`,
        value: formatEuro(donataire?.inputs?.montantRevenantHeritier || donataire?.inputs?.montant_succession || 0),
      };
    });
  };
  const getResultValue = (items, key) => items?.find((item) => item.key === key)?.value;
  const formatRate = (value) => parseInt(Number(value || 0) * 100).toLocaleString("en-EN") + " %";
  const renderSuccessionPdfField = (name, value, key, options = {}) => (
    <View style={[styles.successionField, options.bold ? styles.successionDmtgField : null, options.large ? styles.successionFieldLarge : null]} key={key || name} wrap={false}>
      <Text style={[styles.successionFieldLabel, options.large ? styles.successionFieldLabelLarge : null, options.accent ? styles.successionAccentText : null, options.green ? styles.successionGreenText : null, options.bold ? styles.successionDmtgText : null]}>
        {name}
      </Text>
      <Text style={[styles.successionFieldValue, options.large ? styles.successionFieldValueLarge : null, options.accent ? styles.successionAccentText : null, options.green ? styles.successionGreenText : null, options.bold ? styles.successionDmtgText : null]}>
        {value}
      </Text>
    </View>
  );
  const renderSuccessionPdfOptionField = (item, options = {}) => (
    <View style={[styles.successionField, styles.successionOptionField, options.large ? styles.successionFieldLarge : null]} key={item.key || item.name} wrap={false} minPresenceAhead={42}>
      <Text style={[styles.successionOptionQuestion, options.large ? styles.successionFieldLabelLarge : null]}>{item.name}</Text>
      <View style={styles.successionOptionValueRow}>
        <Text style={[styles.successionOptionValueText, options.large ? styles.successionFieldLabelLarge : null]}>{item.value}</Text>
        <Text style={[styles.successionOptionAmount, options.large ? styles.successionFieldValueLarge : null]}>{item.amount}</Text>
      </View>
    </View>
  );
  const DeathCrossPdfIcon = ({ color = "#333333" }) => (
    <Svg width={8} height={12} viewBox="0 0 8 12" style={styles.successionDeathMarkIcon}>
      <Path d="M4 1v10M1.5 4h5" stroke={color} strokeWidth="1.3" strokeLinecap="round" />
    </Svg>
  );
  const PersonPdfIcon = ({ size = 10 }) => (
    <Svg width={size} height={size} viewBox="0 0 24 24">
      <Circle cx="12" cy="8" r="4" stroke="white" strokeWidth="2" fill="none" />
      <Path d="M4 20c0-4 4-6 8-6s8 2 8 6" stroke="white" strokeWidth="2" fill="none" />
    </Svg>
  );
  const GroupPdfIcon = ({ size = 10 }) => (
    <Svg width={size} height={size} viewBox="0 0 24 24">
      <Circle cx="9" cy="8" r="3" stroke="white" strokeWidth="2" fill="none" />
      <Circle cx="16" cy="9" r="2.5" stroke="white" strokeWidth="2" fill="none" />
      <Path d="M3 19c0-3 3-5 6-5s6 2 6 5" stroke="white" strokeWidth="2" fill="none" />
      <Path d="M14 15c2.2 0 5 1.7 5 4.5" stroke="white" strokeWidth="2" fill="none" />
    </Svg>
  );
  const SummaryPdfIcon = () => (
    <Svg width={12} height={12} viewBox="0 0 24 24" style={styles.successionSummaryIcon}>
      <Rect x="4" y="2" width="16" height="20" rx="2" stroke="white" strokeWidth="1.8" fill="none" />
      <Path d="M7 7h10M7 11h10M7 15h6" stroke="white" strokeWidth="1.8" fill="none" />
    </Svg>
  );
  const renderSuccessionRepartitionRow = (name, value, key, options = {}) => (
    <View style={[styles.successionRepartitionRow, options.noBorder ? styles.successionRepartitionRowNoBorder : null]} key={key || name} wrap={false}>
      <View style={[styles.successionRepartitionIcon, options.greenIcon ? styles.successionRepartitionIconGreen : null]}>
        {options.group ? <GroupPdfIcon size={10} /> : <PersonPdfIcon size={10} />}
      </View>
      {options.represented ? (
        <View style={styles.successionRepartitionNameStack}>
          <Text style={styles.successionRepartitionNameLine}>{options.soucheName}</Text>
          <View style={styles.successionRepartitionHeirLine}>
            <Text style={styles.successionRepartitionNameLine}>({options.heirName} </Text>
            <DeathCrossPdfIcon />
            <Text style={styles.successionRepartitionNameLine}>)</Text>
          </View>
        </View>
      ) : (
        <Text style={styles.successionRepartitionName}>{name}</Text>
      )}
      <Text style={[styles.successionRepartitionValue, options.greenIcon ? styles.successionGreenText : null]}>
        {value}
      </Text>
    </View>
  );
  const renderSuccessionCard = (title, headerStyle, iconStyle, icon, children, key, options = {}) => (
    <View style={[styles.successionCard, options.isSingle ? styles.successionCardSingle : null, options.fullWidth ? styles.successionCardFullWidth : null]} key={key} wrap={options.keepTogether ? false : true}>
      <View style={[styles.successionCardHeader, headerStyle]} wrap={false} minPresenceAhead={130}>
        <View style={[styles.successionCardIcon, iconStyle]}>{icon}</View>
        {options.titleContent ? (
          <View style={styles.successionCardTitleRow}>{options.titleContent}</View>
        ) : (
          <Text style={[styles.successionCardTitle, options.large ? styles.successionCardTitleLarge : null]}>{title}</Text>
        )}
      </View>
      <View style={[styles.successionCardBody, options.large ? styles.successionCardBodyLarge : null]}>{children}</View>
    </View>
  );
  const renderPdfResultLine = (line, index) => {
    if (!line) return null;
    if (line.key === "DMTG") {
      return <Text style={[styles.dmtgResults, styles.dmtgHighlight]} key={line.key || index}>Droits DMTG à payer : {line.value}</Text>;
    }
    if (line.key === "droits_regles_total") {
      return <Text style={styles.dmtgResults} key={line.key || index}>Total des droits déjà réglés : {line.value}</Text>;
    }
    if (line.key === "base_dmtg") {
      return <Text style={styles.dmtgResults} key={line.key || index}>Base Taxable : {line.value}</Text>;
    }
    if (line.key === "montant_revenant_heritier") {
      return <Text style={styles.dmtgResults} key={line.key || index}>Montant lui revenant : {line.value}</Text>;
    }
    if (line.key === "montant_rapportable") {
      return <Text style={styles.dmtgResults} key={line.key || index}>Montant des donations, reçues par l'héritier, rapportables à la succession : {line.value}</Text>;
    }
    if (line.key === "montant_succession") {
      return <Text style={styles.dmtgResults} key={line.key || index}>Montant taxable revenant à l'héritier : {line.value}</Text>;
    }
    if (line.key === "handicap") {
      return <Text style={styles.dmtgResults} key={line.key || index}>Situation de handicap : {line.value}</Text>;
    }
    if (line.key === "montant_article757b") {
      return <Text style={styles.dmtgResults} key={line.key || index}>Montant Article 757 B : {line.value}</Text>;
    }
    if (line.key === "reliquat_total" && line.value !== 0) {
      return (
        <Text style={styles.dmtgResults} key={line.key || index}>
          Déduction faite du reliquat total des parts de tranches non utilisées lors des donations antérieures à 2012 : {line.value}
        </Text>
      );
    }
    if (line.key === "immo") {
      return <Text style={styles.dmtgResults} key={line.key || index}>Montant Immobilier : {line.value}</Text>;
    }
    if (line.key === "especes") {
      return <Text style={styles.dmtgResults} key={line.key || index}>Montant Espèces : {line.value}</Text>;
    }
    if (line.key === "abattement_reconstitue") {
      return <Text style={styles.dmtgResults} key={line.key || index}>Abattement reconstitué : {line.value}</Text>;
    }
    if (line.key === "abattement_total") {
      return <Text style={styles.dmtgResults} key={line.key || index}>Abattement appliqué : {line.value}</Text>;
    }
    if (line.key === "abattement_restant") {
      return <Text style={styles.dmtgResults} key={line.key || index}>Abattement legal restant : {line.value}</Text>;
    }
    if (line.key === "tranche_initiale") {
      if (!hasPositiveValue(line.rawValue)) return null;
      return <Text style={styles.dmtgResults} key={line.key || index}>Taux tranche initiale : {line.value}</Text>;
    }
    if (line.key === "reliquat_tranche_donation" && line.value < 599999999) {
      return <Text style={styles.dmtgResults} key={line.key || index}>Reliquat de tranche initiale non utilisé lors des donations antérieures : {line.value}</Text>;
    }
    if (line.key === "tranche_finale") {
      if (!hasPositiveValue(line.rawValue)) return null;
      return <Text style={styles.dmtgResults} key={line.key || index}>Taux tranche finale : {line.value}</Text>;
    }
    return null;
  };
  const renderSuccessionPdfResultLine = (line, index, options = {}) => {
    if (!line) return null;
    if (line.key === "DMTG") {
      return renderSuccessionPdfField("DMTG à payer", line.value, line.key, { bold: true, large: options.large });
    }
    if (line.key === "droits_regles_total") {
      return renderSuccessionPdfField("Total des droits déjà réglés", line.value, line.key, { large: options.large });
    }
    if (line.key === "base_dmtg") {
      return renderSuccessionPdfField("Base Taxable", line.value, line.key, { large: options.large });
    }
    if (line.key === "montant_revenant_heritier") {
      return renderSuccessionPdfField("Montant lui revenant", line.value, line.key, { large: options.large });
    }
    if (line.key === "montant_rapportable") {
      return renderSuccessionPdfField("Montant des donations, reçues par l'héritier, rapportables à la succession", line.value, line.key, { large: options.large });
    }
    if (line.key === "montant_succession") {
      return renderSuccessionPdfField("Montant taxable revenant à l'héritier", line.value, line.key, { large: options.large });
    }
    if (line.key === "abattement_reconstitue") {
      return renderSuccessionPdfField("Abattement reconstitué", line.value, line.key, { large: options.large });
    }
    if (line.key === "handicap") {
      return renderSuccessionPdfField("Situation de handicap", line.value, line.key, { large: options.large });
    }
    if (line.key === "montant_article757b") {
      return renderSuccessionPdfField("Montant Article 757 B", line.value, line.key, { large: options.large });
    }
    if (line.key === "reliquat_total" && line.value !== 0) {
      return renderSuccessionPdfField("Reliquat total des tranches antérieures à 2012", line.value, line.key, { large: options.large });
    }
    if (line.key === "immo") {
      return renderSuccessionPdfField("Montant Immobilier", line.value, line.key, { large: options.large });
    }
    if (line.key === "especes") {
      return renderSuccessionPdfField("Montant Espèces", line.value, line.key, { large: options.large });
    }
    if (line.key === "abattement_total") {
      return renderSuccessionPdfField("Abattement appliqué", line.value, line.key, { large: options.large });
    }
    if (line.key === "abattement_restant") {
      return renderSuccessionPdfField("Abattement légal restant", line.value, line.key, { large: options.large });
    }
    if (line.key === "tranche_initiale") {
      if (!hasPositiveValue(line.rawValue)) return null;
      return renderSuccessionPdfField("Taux tranche initiale", line.value, line.key, { large: options.large });
    }
    if (line.key === "reliquat_tranche_donation" && line.value < 599999999) {
      return renderSuccessionPdfField("Reliquat de tranche initiale", line.value, line.key, { large: options.large });
    }
    if (line.key === "tranche_finale") {
      if (!hasPositiveValue(line.rawValue)) return null;
      return renderSuccessionPdfField("Taux tranche finale", line.value, line.key, { large: options.large });
    }
    return null;
  };
  const isRepresentantDmtgLine = (key) => /^representant_\d+_(?:article757b_)?dmtg$/.test(key || "");
  const getRepresentantFieldPriority = (key = "") => {
    if (key.endsWith("_title")) return 0;
    if (/^representant_\d+_article757b_/.test(key)) return 4;
    if (key.endsWith("_beneficiaire_assurance_vie") || key.endsWith("_montant_article757b")) return 3;
    return key.endsWith("_dmtg") ? 2 : 1;
  };
  const renderSuccessionRepresentantLine = (line, index, options = {}) => {
    if (!line) return null;
    if (line.key?.endsWith("_title")) {
      return (
        <Text style={[styles.representantTitle, options.large ? styles.representantTitleLarge : null]} key={line.key || index} wrap={false} minPresenceAhead={120}>
          {line.name}
        </Text>
      );
    }
    return renderSuccessionPdfField(line.name, line.value, line.key || index, { bold: isRepresentantDmtgLine(line.key), large: options.large });
  };
  const renderSuccessionRepresentantFallback = (representant, index, output, montantRepresentant, options = {}) => {
    const representantIndex = representant.representant_index || index + 1;
    const representantPrefix = `representant_${representantIndex}`;

    return (
      <View style={styles.representantBlock} key={representantPrefix} minPresenceAhead={120}>
        <Text style={[styles.representantTitle, options.large ? styles.representantTitleLarge : null]} wrap={false}>Représentant {representantIndex}</Text>
        {parseInt(representant.handicap || 0) === 1 ? renderSuccessionPdfField("Situation de handicap", "Oui", `${representantPrefix}_handicap`, { large: options.large }) : null}
        {renderSuccessionPdfField("Montant lui revenant", formatEuro(montantRepresentant), `${representantPrefix}_montant_correspondant`, { large: options.large })}
        {output[`${representantPrefix}_abattement_total`] !== undefined ? renderSuccessionPdfField("Abattement appliqué", formatEuro(Math.round(Number(output[`${representantPrefix}_abattement_total`] || 0))), `${representantPrefix}_abattement_total`, { large: options.large }) : null}
        {output[`${representantPrefix}_abattement_restant`] !== undefined ? renderSuccessionPdfField("Abattement légal restant", formatEuro(Math.round(Number(output[`${representantPrefix}_abattement_restant`] || 0))), `${representantPrefix}_abattement_restant`, { large: options.large }) : null}
        {output[`${representantPrefix}_base_dmtg`] !== undefined ? renderSuccessionPdfField("Base Taxable", formatEuro(Math.round(Number(output[`${representantPrefix}_base_dmtg`] || 0))), `${representantPrefix}_base_dmtg`, { large: options.large }) : null}
        {hasPositiveValue(output[`${representantPrefix}_tranche_initiale`]) ? renderSuccessionPdfField("Taux tranche initiale", formatRate(output[`${representantPrefix}_tranche_initiale`]), `${representantPrefix}_tranche_initiale`, { large: options.large }) : null}
        {hasPositiveValue(output[`${representantPrefix}_tranche_finale`]) ? renderSuccessionPdfField("Taux tranche finale", formatRate(output[`${representantPrefix}_tranche_finale`]), `${representantPrefix}_tranche_finale`, { large: options.large }) : null}
        {output[`${representantPrefix}_dmtg`] !== undefined ? renderSuccessionPdfField("DMTG à payer", formatEuro(Math.round(Number(output[`${representantPrefix}_dmtg`] || 0))), `${representantPrefix}_dmtg`, { bold: true, large: options.large }) : null}
        {parseInt(representant.beneficiaire_assurance_vie || 0) === 1 ? (
          <>
            {renderSuccessionPdfField("Bénéficiaire assurance-vie", "Oui", `${representantPrefix}_beneficiaire_assurance_vie`, { large: options.large })}
            {renderSuccessionPdfField("Montant Article 757 B", formatPositive(representant.montant_taxable_article757b || 0), `${representantPrefix}_montant_article757b`, { large: options.large })}
            {output[`${representantPrefix}_article757b_abattement_total`] !== undefined ? renderSuccessionPdfField("Abattement appliqué", formatEuro(Math.round(Number(output[`${representantPrefix}_article757b_abattement_total`] || 0))), `${representantPrefix}_article757b_abattement_total`, { large: options.large }) : null}
            {output[`${representantPrefix}_article757b_base_dmtg`] !== undefined ? renderSuccessionPdfField("Base taxable", formatEuro(Math.round(Number(output[`${representantPrefix}_article757b_base_dmtg`] || 0))), `${representantPrefix}_article757b_base_dmtg`, { large: options.large }) : null}
            {output[`${representantPrefix}_article757b_dmtg`] !== undefined ? renderSuccessionPdfField("DMTG à payer", formatEuro(Math.round(Number(output[`${representantPrefix}_article757b_dmtg`] || 0))), `${representantPrefix}_article757b_dmtg`, { bold: true, large: options.large }) : null}
          </>
        ) : null}
      </View>
    );
  };
  const renderSuccessionCardContent = (object, donateur, donataire, represented, options = {}) => {
    const currentDonataire = requestSimu?.data?.[donateur]?.donataires?.[donataire];
    const output = currentDonataire?.output || {};
    const representants = Array.isArray(currentDonataire?.representants) ? currentDonataire.representants : [];
    const nombreRepresentants = parseInt(currentDonataire?.inputs?.nombre_representants || representants.length || 0);
    const montantRepresentant = nombreRepresentants > 0
      ? Math.round(parseInt(currentDonataire?.inputs?.montant_succession || 0) / nombreRepresentants)
      : 0;
    const hasRepresentants = represented && representants.length > 0;
    const representantResults = Array.isArray(object) ? object.filter((line) => line?.key?.startsWith("representant_")) : [];

    if (!hasRepresentants) {
      return <View key={donateur}>{object?.map((line, index) => renderSuccessionPdfResultLine(line, index, options))}</View>;
    }

    if (representantResults.length > 0) {
      const soucheResultKeys = ["montant_revenant_heritier", "montant_rapportable", "montant_succession"];
      const soucheResults = Array.isArray(object) ? object.filter((line) => soucheResultKeys.includes(line?.key)) : [];
      const representantBlocks = representantResults.reduce((blocks, line) => {
        if (line?.key?.endsWith("_title")) blocks.push([line]);
        else if (blocks.length > 0) blocks[blocks.length - 1].push(line);
        return blocks;
      }, []);
      return (
        <View key={donateur}>
          {soucheResults.map((line, index) => renderSuccessionPdfResultLine(line, index, options))}
          {representantBlocks.map((block, blockIndex) => (
            <View style={styles.representantBlock} key={`representant-block-${blockIndex}`} minPresenceAhead={120}>
              {block
                .sort((left, right) => getRepresentantFieldPriority(left.key) - getRepresentantFieldPriority(right.key))
                .map((line, index) => renderSuccessionRepresentantLine(line, index, options))}
            </View>
          ))}
        </View>
      );
    }

    return (
      <View key={donateur}>
        {representants.map((representant, index) => renderSuccessionRepresentantFallback(representant, index, output, montantRepresentant, options))}
      </View>
    );
  };

  const page = (
      <Page size="A4" style={styles.page}>
        <View style={styles.headerRight}>
          <StudyLogoPDF user={currUser} />
          <Text style={styles.headerName}>{currUser.societe}</Text>
          <Text style={styles.headerAdress}>{currUser.societe_address}</Text>

          <Text style={styles.headerAdress}>{currUser.societe_zip + " " + currUser.societe_town}</Text>

          <Text style={styles.headerDate}>Dossier suivi par : {currUser.firstname + " " + currUser.lastname}</Text>

          <View style={styles.headerDate}>
            <Text>Le : {currentDate}</Text>
          </View>
        </View>
        <View style={styles.containerTitleSimu}>
          <Text style={styles.titleSimu}>{nameSimu}</Text>
        </View>
        <View style={styles.remarque}>
          <Text style={styles.remarqueText}>Remarques : {remarque}</Text>
        </View>

        <View>
          <Text style={styles.resultsTitle}>Résultat de votre calcul de DMTG :</Text>

          <View style={styles.resultsBlock}>
            {simuDMTGSuccession.includes(requestSimu?.data?.[0]?.donataires?.[0]?.simulateurid) ? (
              <View style={styles.successionDesignContainer}>
                {conjointSurvivantPdf?.synthesisItems?.length > 0 ? (
                  <>
                    <View style={styles.successionSummaryCard} wrap={false}>
                      <View style={styles.successionSummaryHeader} wrap={false}>
                        <SummaryPdfIcon />
                        <Text style={styles.successionSummaryHeaderText}>SYNTHÈSE GLOBALE DE LA SUCCESSION</Text>
                      </View>
                      <View style={styles.successionSummaryBody}>
                        <View style={styles.successionSummaryAmountsCol}>
                          {conjointSurvivantPdf.synthesisItems.map((item) => (
                            item.key === "droits_cs" && item.amount
                              ? renderSuccessionPdfOptionField(item, { large: hasManyRepresentants })
                              : renderSuccessionPdfField(
                                item.name,
                                item.value,
                                item.key,
                                { accent: ["nouvelle_masse_a_partager", "masse_a_partager"].includes(item.key), large: hasManyRepresentants },
                              )
                          ))}
                        </View>
                        <View style={styles.successionSummaryRepartitionCol}>
                          <View style={styles.successionRepartitionBox}>
                            {getResultValue(conjointSurvivantPdf?.resultItems, "droits_cs")
                              ? renderSuccessionRepartitionRow("Conjoint survivant", getResultValue(conjointSurvivantPdf?.resultItems, "droits_cs"), "droits_cs", { greenIcon: true, noBorder: true })
                              : null}
                            <Text style={styles.successionRepartitionTitle}>RÉPARTITION DE LA MASSE À PARTAGER</Text>
                            {getDmtgSuccessionSharingItems().map((item) => renderSuccessionRepartitionRow(item.name, item.value, item.key, {
                              group: item.represented,
                              represented: item.represented,
                              heirName: item.heirName,
                              soucheName: item.soucheName,
                            }))}
                          </View>
                        </View>
                      </View>
                    </View>
                    <View style={styles.successionConnector}>
                      <View style={styles.successionConnectorVertical} />
                      <View style={styles.successionConnectorHorizontal} />
                    </View>
                  </>
                ) : null}
                <View style={styles.successionCards}>
                  {conjointSurvivantPdf?.resultItems?.length > 0
                    ? renderSuccessionCard(
                        "CONJOINT SURVIVANT",
                        styles.successionCardHeaderGreen,
                        styles.successionCardIconGreen,
                        <PersonPdfIcon />,
                        <>
                          {renderSuccessionPdfField("Droits du conjoint survivant", getResultValue(conjointSurvivantPdf.resultItems, "droits_cs") || "0 €", "droits_cs", { large: hasManyRepresentants })}
                          {renderSuccessionPdfField("DMTG à payer", "0 €", "conjoint_dmtg", { bold: true, large: hasManyRepresentants })}
                        </>,
                        "conjoint-survivant",
                        { isSingle: successionResultCardsCount < 2, fullWidth: hasManyRepresentants || hasSingleHeirCard, large: hasManyRepresentants, keepTogether: true }
                      )
                    : null}
                  {result?.map((array, donataire) => {
                    const represented = parseInt(requestSimu?.data?.[0]?.donataires?.[donataire]?.inputs?.est_represente || 0) === 1;
                    const titleStyle = [styles.successionCardTitle, hasManyRepresentants ? styles.successionCardTitleLarge : null];
                    return renderSuccessionCard(
                      represented ? `SOUCHE ${donataire + 1}` : `HÉRITIER ${donataire + 1}`,
                      styles.successionCardHeaderBlue,
                      null,
                      represented ? <GroupPdfIcon /> : <PersonPdfIcon />,
                      array?.map((object, donateur) => renderSuccessionCardContent(object, donateur, donataire, represented, { large: hasManyRepresentants })),
                      `heritier-${donataire}`,
                      {
                        isSingle: successionResultCardsCount < 2,
                        fullWidth: hasManyRepresentants || hasSingleHeirCard,
                        large: hasManyRepresentants,
                        titleContent: represented ? (
                          <>
                            <Text style={titleStyle}>SOUCHE {donataire + 1} (Héritier {donataire + 1} </Text>
                            <DeathCrossPdfIcon color="white" />
                            <Text style={titleStyle}>)</Text>
                          </>
                        ) : null,
                      }
                    );
                  })}
                </View>
              </View>
            ) : (
              result?.map((array, donataire) => (
                <View style={styles.donataireBlock} wrap={false} key={donataire}>
                  <Text style={styles.donataireTitle}>Donataire {donataire + 1}</Text>
                  {array?.map((object, donateur) => (
                    <View style={styles.donateurBlock} wrap={false} key={donateur}>
                      <Text style={styles.donateurTitle}>Donateur {donateur + 1}</Text>
                      <View style={styles.donateurResults}>
                        {object?.map((line, index) => renderPdfResultLine(line, index))}
                      </View>
                    </View>
                  ))}
                </View>
              ))
            )}
          </View>
        </View>

        {/* MAP FOR INPUTS*/}

        <View style={styles.rappel}>
          <Text style={styles.bodyFooterMappedTitle} wrap={false} minPresenceAhead={220}>Rappel de votre simulation :</Text>
          <View style={styles.rappelGrid}>

          {conjointSurvivantPdf?.items?.length > 0 ? (
            <View style={styles.rappelBlockDonataire} wrap={false}>
              <Text style={styles.rappelConjointSurvivantTitle}>Conjoint survivant</Text>
              {conjointSurvivantPdf.items.map((item) => (
                <Text style={styles.bodyFooterMapped} key={item.key}>
                  {item.name} : {item.value}
                </Text>
              ))}
            </View>
          ) : null}

          {requestSimu?.data?.map((array, donateur) => {
            if (simuDMTGSuccession.includes(requestSimu.data[0].donataires[0].simulateurid)) {
              return (
                <>
                  {requestSimu?.data[donateur]?.donataires?.map((inputs, donataire) => {
                    const representants = Array.isArray(requestSimu?.data[donateur]?.donataires[donataire]?.representants)
                      ? requestSimu?.data[donateur]?.donataires[donataire]?.representants
                      : [];
                    const nombreRepresentants = parseInt(requestSimu?.data[donateur]?.donataires[donataire]?.inputs?.nombre_representants || representants.length || 0);
                    const montantRepresentant = Math.round(parseInt(requestSimu?.data[donateur]?.donataires[donataire]?.inputs?.montant_succession || 0) / nombreRepresentants);
                    return (
                      <>
                        <View style={styles.rappelBlockDonataire} wrap={false}>
                          <Text style={styles.rappelDonataireTitle}>
                            {parseInt(requestSimu?.data[donateur]?.donataires[donataire]?.inputs?.est_represente || 0) === 1 ? "Souche" : "Héritier"} {donataire + 1}
                          </Text>
                          {Object.keys(requestSimu?.data[donateur]?.donataires[donataire]?.inputs)?.map((key) => {
                            if (key === "lien_parente_donation") {
                              if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 1) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>
                                    Lien de parenté : Entre époux ou partenaires pacsés
                                  </Text>
                                );
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 2) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>
                                    Lien de parenté : En ligne directe - Ascendants ou enfants
                                  </Text>
                                );
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 3) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>Lien de parenté : Entre frères et sœurs</Text>
                                );
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 4) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>Lien de parenté : Aux neveux et nièces</Text>
                                );
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 5) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>Lien de parenté : Aux petits-enfants</Text>
                                );
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 6) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>
                                    Lien de parenté : Aux arrières petits-enfants
                                  </Text>
                                );
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 7) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>
                                    Lien de parenté : Entre parents au-dela du 4ème degré et non parents
                                  </Text>
                                );
                              }
                            } else if (key === "lien_parente_succession") {
                              if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 1) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>
                                    Lien de parenté : En ligne directe - Ascendants ou enfants
                                  </Text>
                                );
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 2) {
                                if (
                                  requestSimu?.data[donateur]?.donataires[donataire]?.inputs[
                                    "conditions_particulieres"
                                  ] === 1
                                ) {
                                  return (
                                    <Text style={styles.bodyFooterMapped}>
                                      Lien de parenté : Entre frères et sœurs Conditions particulières : Oui
                                    </Text>
                                  );
                                } else if (
                                  requestSimu?.data[donateur]?.donataires[donataire]?.inputs[
                                    "conditions_particulieres"
                                  ] === 0
                                ) {
                                  return (
                                    <Text style={styles.bodyFooterMapped}>
                                      Lien de parenté : Entre frères et sœurs Conditions particulières : Non
                                    </Text>
                                  );
                                }
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 3) {
                                if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs["propre_chef"] === 1) {
                                  return (
                                    <Text style={styles.bodyFooterMapped}>
                                      Lien de parenté : Aux neveux et nièces De leur propre-chef : Oui
                                    </Text>
                                  );
                                } else if (
                                  requestSimu?.data[donateur]?.donataires[donataire]?.inputs["propre_chef"] === 0
                                ) {
                                  return (
                                    <Text style={styles.bodyFooterMapped}>
                                      Lien de parenté : Aux neveux et nièces De leur propre-chef : Non
                                    </Text>
                                  );
                                }
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 4) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>
                                    Lien de parenté : Entre collatéraux jusqu'au 4ème degré inclusivement
                                  </Text>
                                );
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 5) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>
                                    Lien de parenté : Entre parents au-delà du 4ème degré et non parents
                                  </Text>
                                );
                              }
                            } else if (key === "date_nouvelle_donation") {
                              const date_nouvelle_donation =
                                requestSimu.data[donateur]?.donataires[donataire]?.inputs[key];
                              const date = moment(date_nouvelle_donation).format("DD/MM/YYYY");
                              return (
                                <Text style={styles.bodyFooterMapped} key={key}>
                                  Date du décès : {date}
                                </Text>
                              );
                            } else if (key === "total_succession") {
                              const total_succession =
                                requestSimu?.data[donateur]?.donataires[donataire]?.inputs["total_succession"];
                              const montant_rapportable =
                                requestSimu?.data[donateur]?.donataires[donataire]?.inputs["montant_rapportable"];
                              const montantSuccession =
                                requestSimu?.data[donateur]?.donataires[donataire]?.inputs["montant_succession"];
                              const montantRevenantHeritier =
                                requestSimu?.data[donateur]?.donataires[donataire]?.inputs["montantRevenantHeritier"];
                              return (
                                <>
                                  <Text style={styles.bodyFooterMapped}>
                                    Masse à partager avec l'ensemble des héritiers : {total_succession} €
                                  </Text>
                                  <Text style={styles.bodyFooterMapped}>
                                    Dont revenant à l'héritier : {montantRevenantHeritier} €
                                  </Text>
                                  <Text style={styles.bodyFooterMapped}>
                                    Sous déduction du montant de son rapport : {montant_rapportable} €
                                  </Text>
                                  <Text style={styles.bodyFooterMapped} key={key}>
                                    Montant taxable revenant à l'héritier : {montantSuccession} €
                                  </Text>
                                </>
                              );
                            } else if (key === "abattement_reconstitue" && Number(requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] || 0) > 0) {
                              return <Text style={styles.bodyFooterMapped} key={key}>Abattement reconstitué dans le rappel fiscal : {requestSimu.data[donateur].donataires[donataire].inputs[key]} €</Text>;
                            } else if (key === "montant_utilise") {
                              return (
                                <Text style={styles.bodyFooterMapped}>
                                  Abattement légal déjà utilisé :{" "}
                                  {(requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] ?? 0).toString() + " €"}
                                </Text>
                              );
                            }
                            return <></>;
                          })}
                          {requestSimu?.data[donateur]?.donataires[donataire]?.donations_anterieures &&
                          requestSimu?.data[donateur]?.donataires[donataire]?.donations_anterieures.some(
                            isValidPreviousDonation
                          )
                            ? requestSimu?.data[donateur]?.donataires[donataire]?.donations_anterieures.filter(isValidPreviousDonation).map(
                                (donation, index) => {
                                  const date = moment(Number(donation.date)).format("DD/MM/YYYY");
                                  const montant = (donation.montant ?? 0).toString() + " €";
                                  const droitsRegles = donation.droits_regles ? donation.droits_regles.toString() + " €" : "0 €";
                                  return (
                                    <View key={index}>
                                      <Text style={styles.bodyFooterMapped}>
                                        {`Donation antérieure ${index + 1} - Date : ${date}`}
                                      </Text>
                                      <Text style={styles.bodyFooterMapped}>
                                        {`Donation antérieure ${index + 1} - Montant : ${montant}`}
                                      </Text>
                                      {donation.droits_regles && donation.droits_regles !== 0 && (
                                        <Text style={styles.bodyFooterMapped}>
                                          {`Donation antérieure ${index + 1} - Droits réglés : ${droitsRegles}`}
                                        </Text>
                                      )}
                                    </View>
                                  );
                                }
                              )
                            : null}
                          {parseInt(requestSimu?.data[donateur]?.donataires[donataire]?.inputs?.est_represente || 0) === 1 && representants.length > 0
                            ? representants.map((representant, index) => (
                                <View key={index}>
                                  <Text style={styles.bodyFooterMapped}>
                                    Représentant {representant.representant_index || index + 1} - Montant lui revenant : {formatEuro(montantRepresentant)}
                                  </Text>
                                  <Text style={styles.bodyFooterMapped}>
                                    Représentant {representant.representant_index || index + 1} - Situation de handicap : {parseInt(representant.handicap || 0) === 1 ? "Oui" : "Non"}
                                  </Text>
                                  <Text style={styles.bodyFooterMapped}>
                                    Représentant {representant.representant_index || index + 1} - Bénéficiaire assurance-vie : {parseInt(representant.beneficiaire_assurance_vie || 0) === 1 ? "Oui" : "Non"}
                                  </Text>
                                  {parseInt(representant.beneficiaire_assurance_vie || 0) === 1 ? (
                                    <>
                                      <Text style={styles.bodyFooterMapped}>
                                        Représentant {representant.representant_index || index + 1} - Montant Article 757 B : {formatPositive(representant.montant_taxable_article757b)}
                                      </Text>
                                      {/*
                                        <Text style={styles.bodyFooterMapped}>
                                          Représentant {representant.representant_index || index + 1} - Part restante de l'abattement légal du représentant : {formatEuro(representant.part_abattement_legal_restant || 0)}
                                        </Text>
                                      */}
                                    </>
                                  ) : null}
                                </View>
                              ))
                            : null}
                        </View>
                      </>
                    );
                  })}
                </>
              );
            } else {
              return (
                <>
                  <Text style={[styles.rappelDonateurTitle, styles.rappelGridTitle]} wrap={false}>
                    Donateur {donateur + 1}
                  </Text>
                  {requestSimu?.data[donateur]?.donataires?.map((inputs, donataire) => {
                    return (
                      <>
                        <View style={styles.rappelBlockDonataire} wrap={false}>
                          <Text style={styles.rappelDonataireTitle}>Donataire {donataire + 1}</Text>
                          {Object.keys(requestSimu?.data[donateur]?.donataires[donataire]?.inputs)?.map((key) => {
                            if (key === "lien_parente_donation") {
                              if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 1) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>
                                    Lien de parenté : Entre époux ou partenaires pacsés
                                  </Text>
                                );
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 2) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>
                                    Lien de parenté : En ligne directe - Ascendants ou enfants
                                  </Text>
                                );
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 3) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>Lien de parenté : Entre frères et sœurs</Text>
                                );
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 4) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>Lien de parenté : Aux neveux et nièces</Text>
                                );
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 5) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>Lien de parenté : Aux petits-enfants</Text>
                                );
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 6) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>
                                    Lien de parenté : Aux arrières petits-enfants
                                  </Text>
                                );
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 7) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>
                                    Lien de parenté : Entre parents au-dela du 4ème degré et non parents
                                  </Text>
                                );
                              }
                            } else if (key === "lien_parente_succession") {
                              if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 1) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>
                                    Lien de parenté : En ligne directe - Ascendants ou enfants
                                  </Text>
                                );
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 2) {
                                if (
                                  requestSimu?.data[donateur]?.donataires[donataire]?.inputs[
                                    "conditions_particulieres"
                                  ] === 1
                                ) {
                                  return (
                                    <Text style={styles.bodyFooterMapped}>
                                      Lien de parenté : Entre frères et sœurs Conditions particulières : Oui
                                    </Text>
                                  );
                                } else if (
                                  requestSimu?.data[donateur]?.donataires[donataire]?.inputs[
                                    "conditions_particulieres"
                                  ] === 0
                                ) {
                                  return (
                                    <Text style={styles.bodyFooterMapped}>
                                      Lien de parenté : Entre frères et sœurs Conditions particulières : Non
                                    </Text>
                                  );
                                }
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 3) {
                                if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs["propre_chef"] === 1) {
                                  return (
                                    <Text style={styles.bodyFooterMapped}>
                                      Lien de parenté : Aux neveux et nièces De leur propre-chef : Oui
                                    </Text>
                                  );
                                } else if (
                                  requestSimu?.data[donateur]?.donataires[donataire]?.inputs["propre_chef"] === 0
                                ) {
                                  return (
                                    <Text style={styles.bodyFooterMapped}>
                                      Lien de parenté : Aux neveux et nièces De leur propre-chef : Non
                                    </Text>
                                  );
                                }
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 4) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>
                                    Lien de parenté : Entre collatéraux jusqu'au 4ème degré inclusivement
                                  </Text>
                                );
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 5) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>
                                    Lien de parenté : Entre parents au-delà du 4ème degré et non parents
                                  </Text>
                                );
                              }
                            } else if (key === "tepa") {
                              if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 1) {
                                return (
                                  <>
                                    <Text style={styles.bodyFooterMapped}>
                                      Exonération pour don familial de somme d'argent : Oui
                                    </Text>
                                    <Text style={styles.bodyFooterMapped}>
                                      Abattement TEPA déjà utilisé :{" "}
                                      {(requestSimu?.data[donateur]?.donataires[donataire]?.inputs[
                                        "montant_tepa_utilise"
                                      ] ?? 0).toString() + " €"}
                                    </Text>
                                  </>
                                );
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 0) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>
                                    Exonération pour don familial de somme d'argent : Non
                                  </Text>
                                );
                              }
                            } else if (key === "abattement_reconstitue" && Number(requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] || 0) > 0) {
                              return <Text style={styles.bodyFooterMapped} key={key}>Abattement reconstitué dans le rappel fiscal : {requestSimu.data[donateur].donataires[donataire].inputs[key]} €</Text>;
                            } else if (key === "montant_utilise") {
                              return (
                                <Text style={styles.bodyFooterMapped}>
                                  Abattement légal déjà utilisé :{" "}
                                  {(requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] ?? 0).toString() + " €"}
                                </Text>
                              );
                            } else if (key === "handicap") {
                              if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 1) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>
                                    Bénéficiaire en situation de handicap : Oui
                                  </Text>
                                );
                              } else if (requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] === 0) {
                                return (
                                  <Text style={styles.bodyFooterMapped}>
                                    Bénéficiaire en situation de handicap : Non
                                  </Text>
                                );
                              }
                            } else if (key === "montant_especes") {
                              return (
                                <Text style={styles.bodyFooterMapped}>
                                  Montant espèces :{" "}
                                  {(requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] ?? 0).toString() + " €"}
                                </Text>
                              );
                            } else if (key === "montant_immo") {
                              return (
                                <Text style={styles.bodyFooterMapped}>
                                  Montant immobilier :{" "}
                                  {(requestSimu?.data[donateur]?.donataires[donataire]?.inputs[key] ?? 0).toString() + " €"}
                                </Text>
                              );
                            } else if (key === "date_nouvelle_donation") {
                              const date_nouvelle_donation =
                                requestSimu.data[donateur]?.donataires[donataire]?.inputs[key];
                              const date = moment(date_nouvelle_donation).format("DD/MM/YYYY");
                              const montantDonation =
                                requestSimu?.data[donateur]?.donataires[donataire]?.inputs["montant_donation"];

                              return (
                                <>
                                  <Text style={styles.bodyFooterMapped} key={key}>
                                    Nouvelle donation - Date : {date}
                                  </Text>
                                  <Text style={styles.bodyFooterMapped} key={key}>
                                    Nouvelle donation - Montant : {montantDonation} €
                                  </Text>
                                </>
                              );
                            }
                            return <></>;
                          })}

                          {requestSimu?.data[donateur]?.donataires[donataire]?.donations_anterieures &&
                          requestSimu?.data[donateur]?.donataires[donataire]?.donations_anterieures.some(
                            isValidPreviousDonation
                          )
                            ? requestSimu?.data[donateur]?.donataires[donataire]?.donations_anterieures.filter(isValidPreviousDonation).map(
                                (donation, index) => {
                                  const date = moment(Number(donation.date)).format("DD/MM/YYYY");
                                  const montant = (donation.montant ?? 0).toString() + " €";
                                  const droitsRegles = donation.droits_regles ? donation.droits_regles.toString() + " €" : "0 €";
                                  return (
                                    <View key={index}>
                                      <Text style={styles.bodyFooterMapped}>
                                        {`Donation antérieure ${index + 1} - Date : ${date}`}
                                      </Text>
                                      <Text style={styles.bodyFooterMapped}>
                                        {`Donation antérieure ${index + 1} - Montant : ${montant}`}
                                      </Text>
                                      {donation.droits_regles && donation.droits_regles !== 0 && (
                                        <Text style={styles.bodyFooterMapped}>
                                          {`Donation antérieure ${index + 1} - Droits réglés : ${droitsRegles}`}
                                        </Text>
                                      )}
                                    </View>
                                  );
                                }
                              )
                            : null}
                        </View>
                      </>
                    );
                  })}
                </>
              );
            }
          })}
          </View>
        </View>

        <View style={styles.bodyFooterCtn} fixed>
          <Text style={styles.bodyFooterBold}>
            IMPORTANT : Les informations et les résultats présentés ci-dessus sont donnés à titre indicatif et ne
            peuvent en aucun cas constituer un document à caractère contractuel. Les frais indiqués doivent être
            adressés par virement au minimum 48h-72h à l'avance.
          </Text>
          <Text style={styles.bodyFooterLight}>Sources : Éditions Langloÿs - Le Barème Rapide® {year}</Text>
        </View>
      </Page>
  );
  return embedded ? page : <Document>{page}</Document>;
};

export default GenerateDMTGPdfFile;
